<div id="academy-course35" class="page-layout simple left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="sidebarWizardCGO" position="left" lockedOpen="gt-md">
        <!-- HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center" style="background-color: brown;">
            <div style="flex: 2 0 0;">
                <h1>CGO NOM-035-STPS-2018</h1>
            </div>

            <button fxHide.gt-md style="flex: 1 0 0;" mat-icon-button class="mr-16" fxLayoutAlign="end center" (click)="toggleSidebar('sidebarWizardCGO')">
              <mat-icon>arrow_back</mat-icon>
          </button>

        </div>
        <!-- / HEADER -->
        <!-- SIDEBAR CONTENT -->
        <div class="content" fusePerfectScrollbar>

            <ng-container *ngIf="!arbolCargado">
                <div fxLayout="column" fxLayoutAlign="space-between center" class="p-20">
                    <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
                    <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
                </div>
            </ng-container>

            <div *ngIf="arbolCargado" class="steps Style-tree" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
                <mat-tree [dataSource]="dataSourceTree" [treeControl]="treeControl">
                    <!-- This is the tree node template for leaf nodes -->
                    <!--[ngClass]="'completed'"-->

                    <mat-tree-node (click)="gotoStep(node.pos);" class="step pl-10 fade" routerLink="{{node.ruta}}" routerLinkActive="active" *matTreeNodeDef="let node; let k = index;" matTreeNodePadding [ngClass]="{'completedTask': node.status == 3, 'uncompletedTask': node.status == 1, 'uncompletedTask': node.status == 2, 'seleccionado': Step_Select === node.status, 'seleccionado': currentStep === node.pos}">
                        <!-- use a disabled button to provide padding for tree leaf -->
                        <button mat-icon-button active class="fade Efect-tree" mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                            <mat-icon class=" mat-icon-rtl-mirror" >
                                {{treeControl.isExpanded(node.name) ? 'more_horiz' : 'chevron_right'}}
                            </mat-icon>
                        </button>
                        <p style="padding-right:50px;"> {{node.name | translate}} </p>
                    </mat-tree-node><br>

                    <!-- This is the tree node template for expandable nodes -->
                    <mat-tree-node (click)="gotoStep(node.pos);" class="step pl-10 fade Efect-tree" routerLink="{{node.ruta}}" routerLinkActive="active" *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding [ngClass]="{'completedTask': node.status == 3, 'uncompletedTask': node.status == 1, 'uncompletedTask': node.status == 2, 'seleccionado': Step_Select === node.status, 'seleccionado': currentStep === node.pos}">
                        <button class=" fade Efect-tree " mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                <mat-icon class=" mat-icon-rtl-mirror" >
                                    {{treeControl.isExpanded(node) ? 'arrow_drop_up' : 'arrow_drop_down_circle'}}
                                </mat-icon>
                            </button>
                        <p style="padding-right:80px; text-align: left; ">{{node.name | translate}} </p>
                    </mat-tree-node>
                </mat-tree>
            </div>

        </div>
        <!-- / SIDEBAR CONTENT -->

    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div fxLayout="row" fxLayoutAlign="start center" fxHide.gt-md>
            <button style="flex: 1 0 0;" mat-icon-button class="sidebar-toggle mr-16" fxHide.gt-md (click)="toggleSidebar('sidebarWizardCGO')">
            <mat-icon>menu</mat-icon>
        </button>

            <div style="flex: 2 0 0;">
                <h2>CGO NOM-035-STPS-2018</h2>
            </div>
        </div>


        <!-- CONTENT -->
        <div id="course-content" class="content">
            <ng-container>
                <div class="course-step" fusePerfectScrollbar>
                    <!--div id="course-step-content" class="course-step-content" [innerHTML]="step.content"></div-->
                    <div id="course-step-content" class="course-step-content">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </ng-container>
        </div>


    </div>
    <!-- / CENTER -->

</div>